// import React from 'react'
import { Button } from '@mui/material'
import { withStyles } from '@mui/styles'
import { red } from '@mui/material/colors'
import LoadingButton from '@mui/lab/LoadingButton';

export const ButtonCancel = withStyles((theme) => ({
root:{
    
    color: '#fff',
    backgroundColor: red[500],
}

}))(Button)

export const ButtonSubmit = withStyles((theme) => ({
    root:{
        
        color: '#fff',
        backgroundColor:"rgb(0 165 73 / 89%)"
    }
    
    }))(Button)
 


    export const ButtonSubmitProgress = withStyles((theme) => ({
        root:{
            
            color: '#fff',
            backgroundColor:"rgb(0 165 73 / 89%)"
        }
        
        }))(LoadingButton)
     
    